import { Component, OnInit, Input, EventEmitter, Output, OnDestroy, inject } from '@angular/core'
import { BreakpointService } from '@lib/master-detail'
import { IconNamesEnum, NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { Article, MegaMenuLink, selectPreviousAndNextByRunningOrder } from '../../../state'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { SavedSearchService } from 'src/app/services/saved-search.service'
import { selectUser } from 'src/app/state/user.reducer'
import { BreadcrumbButtonBarService } from 'src/app/services/breadcrumb-button-bar-service'
import { ButtonConfiguration } from 'src/app/services/button-configuration.interface'
import { MasterRouterLinkDirective } from '../../../../../projects/lib-master-detail/src/lib/directives/master-router-link.directive'
import { NgTemplateOutlet, AsyncPipe } from '@angular/common'
import { RouterLink } from '@angular/router'

@Component({
    selector: 'app-header',
    templateUrl: './detail-header.component.html',
    styleUrls: ['./detail-header.component.scss'],
    imports: [RouterLink, NgxBootstrapIconsModule, NgTemplateOutlet, MasterRouterLinkDirective, AsyncPipe]
})
export class HeaderComponent implements OnInit, OnDestroy {
  breakpointService = inject(BreakpointService)
  store = inject<Store<any>>(Store)
  private savedSearchService = inject(SavedSearchService)
  private breadcrumbButtonBarService = inject(BreadcrumbButtonBarService)


  public defaultTitle = ''
  public iconNames = IconNamesEnum
  public article: Article | undefined

  public user$: Subscription = Subscription.EMPTY
  public followArticleSearch: any | undefined = undefined

  @Input() title = this.defaultTitle
  @Input() showBack = false
  @Input() showFollow = true
  @Input() followOptions: [string, boolean, string?][] = []
  @Input() backRoute = '../../'
  @Input() contentSet = ''
  @Input('article') set setUpPreviousAndNext(article: Article) {
    this.article = article
    this.previousAndNext$ = this.store.select(selectPreviousAndNextByRunningOrder(article.runningOrder))
  }

  @Output() nextarticle = new EventEmitter<number>()

  public previousAndNext$: Observable<string[]> = new Observable()

  ngOnInit() {
    if (this.showFollow) {
      this.user$ = this.store.select(selectUser).subscribe(user => {
        this.followArticleSearch = user?.searches?.[this.contentSet]?.find((search: any) => search.parameters.id === this.article!.id)
        let newButton: ButtonConfiguration
        if (this.followArticleSearch ?? 0 > 0) {
          newButton = {
            label: 'Unfollow',
            class: "btn btn-sm btn-outline-bankruptcydata",
            icon: IconNamesEnum.AlarmFill,
            clickAction: () => {
              this.unfollowArticle(this.article!)
            },
          }
        } else {
          newButton = {
            label: 'Follow',
            class: "btn btn-sm btn-outline-bankruptcydata",
            icon: IconNamesEnum.Alarm,
            clickAction: () => {
              this.followArticle(this.article!)
            },
          }
        }

        this.breadcrumbButtonBarService.removeAllButtons()
        this.breadcrumbButtonBarService.addButton(newButton)
      })
    }
  }

  ngOnDestroy(): void {
    this.breadcrumbButtonBarService.removeAllButtons()
    this.user$.unsubscribe()
  }

  expandListing(event: Event) {
    this.breakpointService.setExpandListing(true)
  }


  followArticle(article: Article) {
    this.savedSearchService.saveSearch({
      parameters: {
        area: this.contentSet,
        id: article.id,
        options: this.followOptions
      },
      area: this.contentSet,
      type: 'follow',
      name: 'Follow: ' + article.title
    })
  }

  unfollowArticle(article: Article) {
    this.savedSearchService.deleteSearch(this.followArticleSearch)
  }
}